import { configureStore } from "@reduxjs/toolkit";
import panNumberReducer from "./panNumberSlice";
import rootReducer from "./dexterrPortfolio/reducers";
import storedTokenReducer from "../Store/Token/AuthTokenSlice";
import updatedPortfolioReducer from "./UpdatedPortfolioData/updatedPortfolioSlice";
import phoneNumberReducer from "./MobileSlice";
import userPortfolioSlice from "./UpdatedPortfolioData/userPortfolioSlice";
import transactionReducer from "./TransactionNoSlice";
import refreshTokenReducer from "./Token/refreshTokenSlice";
import StateCodeReducer from "./StateCodeSlice";
import BankNameReducer from "./UserBankSlice";
import IinNumberReducer from "./IINSlice";
import SelectPortFolioReducer from "./SelectedPortFolioSlice";
import OtpLessDataReducer from "./OtpLessData"
import addressReducer from './addressSlice';
import stateSlice from "./stateSlice"; 
import loginTokenReducer from './loginTokenSlice';

export const store = configureStore({
  reducer: {
    panNumber: panNumberReducer,
    dexterrPortfolio: rootReducer,
    storedToken: storedTokenReducer,
    updatedPortfolio: updatedPortfolioReducer,
    phoneNumber: phoneNumberReducer,
    portfolio: userPortfolioSlice,
    transaction: transactionReducer,
    refreshToken: refreshTokenReducer,
    StateCode: StateCodeReducer,
    BankName: BankNameReducer,
    iinNumber: IinNumberReducer,
    SelectedPortFolioType: SelectPortFolioReducer,
    OtpLessData:OtpLessDataReducer,
    address: addressReducer,
    state: stateSlice,
    loginToken: loginTokenReducer,
    

  },
});
